import PropTypes from 'prop-types'
import { ESTADO_PAUSADA, ESTADO_VENCIDA } from '../../../constants/publicaciones.js'
import { validarRangoFechas } from '../../../helpers/dateValidation.js'
import { formatearFecha } from '../../helpers/helper.js'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import styles from './Estado.module.css'

const ESTADO = [
  { idPublicacionEstado: 2, nombre: 'Publicada' },
  { idPublicacionEstado: 3, nombre: 'Pausada' },
  { idPublicacionEstado: 5, nombre: 'Vencida' }
]

const Estado = ({ value, onChange, vigenciaHasta, fechaReactivacion, estadoInicial }) => {
  const selectDeshabilitado =
    estadoInicial === ESTADO_VENCIDA &&
    validarRangoFechas(new Date(vigenciaHasta), new Date(), 'day')

  const estaPausadaAutomaticamente =
    value === ESTADO_PAUSADA &&
    fechaReactivacion &&
    validarRangoFechas(new Date(), new Date(fechaReactivacion), 'second')

  const fechaReactivacionFormateada = formatearFecha(fechaReactivacion, 'FH')

  return (
    <div className={styles.container}>
      <span className={styles.label}>Cambiar estado a:</span>
      <GenericSelect
        name="idPublicacionEstado"
        onChange={(val) =>
          onChange(
            {
              currentTarget: { name: 'idPublicacionEstado', value: val, type: 'select' }
            },
            'num'
          )
        }
        value={value}
        className={styles.select}
        options={ESTADO.map((e) => ({
          value: e.idPublicacionEstado,
          label: e.nombre,
          key: e.idPublicacionEstado
        }))}
        placeholder="Seleccionar estado"
        disabled={selectDeshabilitado || estaPausadaAutomaticamente}
      />
      {selectDeshabilitado && (
        <small className="warningMessage">
          Para modificar el estado de la publicación, es necesario actualizar la fecha de vigencia a
          un día posterior al actual.
        </small>
      )}
      {estaPausadaAutomaticamente && (
        <small className="warningMessage">
          La publicación se reactivará automáticamente el {fechaReactivacionFormateada} y no puede
          modificarse el estado hasta entonces.
        </small>
      )}
    </div>
  )
}

Estado.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  vigenciaHasta: PropTypes.string.isRequired,
  fechaReactivacion: PropTypes.string,
  estadoInicial: PropTypes.number.isRequired
}

export default Estado
